import { useState, useEffect } from 'react';
import { postActivity, editActivity } from '../supabase';

const AdminForm = (props) => {
    const { admin, editMode, activity, getSchedules } = props;
    const [title, setTitle] = useState('');
    const [place, setPlace] = useState('');
    const [campoOption, setCampoOption] = useState('Castel San Giorgio');
    const [date, setDate] = useState(new Date().toISOString().split('T')[0]);
    const [hour, setHour] = useState('');
    const [meeting, setMeeting] = useState('');
    const [info, setInfo] = useState('');
    const [type, setType] = useState('Torneo');
    const [end, setEnd] = useState('');
    const [setup, setSetup] = useState('Libero'); 
    const [appointment, setAppointment] = useState('');
console.log(activity, getSchedules);
    // Load activity data when in edit mode
    useEffect(() => {
        if (editMode && activity) {
            console.log("Loading activity data:", activity);
            setTitle(activity.title || '');
            setPlace(activity.campo || '');
            const predefinedCampi = ['Castel San Giorgio', 'Mercato San Severino'];
            if (activity.campo && predefinedCampi.includes(activity.campo)) {
                setCampoOption(activity.campo);
            } else if (activity.campo) {
                setCampoOption('Altro');
            } else {
                setCampoOption('Castel San Giorgio');
            }
            setDate(activity.date || new Date().toISOString().split('T')[0]);
            setHour(activity.time || '');
            setMeeting(activity.where || '');
            setInfo(activity.desc || '');
            setType(activity.type || 'Torneo');
            setEnd(activity.end || '');
            setSetup(activity.setup || 'Libero'); 
            setAppointment(activity.appointment_hour || '');
        }
    }, [editMode, activity]); // Add activity to dependency array

    const LOV_TYPE = ['Torneo', 'Allenamento', 'Amichevole', 'Evento', 'Altro', 'Torneo FIGT'];
    const LOV_SETUP = ['Libero', 'Squadra', 'Altro'];

    const handleSubmit = async () => {
        console.log(title, type, place, date, hour, meeting, info, end, setup, appointment);
        if (!title) {
            alert('Inserisci titolo')
            return
        }

        if (!type) {
            alert('Inserisci tipo')
            return
        }

        if (!place) {
            alert('Inserisci luogo')
            return
        }

        if (!date) {
            alert('Inserisci data')
            return
        }

        if (!hour) {
            alert('Inserisci ora inizio')
            return
        }

        if (!meeting) {
            alert('Inserisci luogo incontro')
            return
        }

        if (!end) {
            alert('Inserisci ora fine')
            return
        }

        if (!setup) {
            alert('Inserisci setup')
            return
        }
 

        if (!appointment) {
            alert('Inserisci ora appuntamento')
            return
        } 
        if (admin) {
            if (editMode && activity) {
                // Edit existing activity
                await editActivity(
                    activity.id,
                    title,
                    type,
                    place,
                    date,
                    hour,
                    meeting,
                    info,
                    end,
                    setup, 
                    appointment
                );
                // Refresh the schedule list
                if (getSchedules) getSchedules();
            } else {
                // Create new activity
                await postActivity(
                    title,
                    type,
                    place,
                    date,
                    hour,
                    meeting,
                    info,
                    end,
                    setup, 
                    appointment
                );
                // Refresh the schedule list if available
                if (getSchedules) getSchedules();
            }
            
            // Clear form after submission if needed
            if (!editMode) {
                setTitle('');
                setPlace('');
                setDate(new Date().toISOString().split('T')[0]);
                setHour('');
                setMeeting('');
                setInfo('');
                setType('Torneo');
                setEnd('');
                setSetup('Libero');
                setAppointment('');
            }
        } else {
            console.log('not admin');
        }
    };

    return (
        <div className="w-full pb-36 bg-bg-lg">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-5 gap-y-4">
                <div className="sm:col-span-2">
                    <p className="text-xl font-bold text-white">
                        {editMode ? 'Modifica giocata' : 'Creazione giocata'}
                    </p>
                </div>
                
                <div className='w-full'>
                    <p className="text-base font-medium text-white"> Giorno </p>
                    <input type="date" value={date} onChange={e => setDate(e.target.value)} className="flex w-full h-14 text-black placeholder-gray-500 bg-white border border-gray-200 rounded-md caret-blue-600 p-2" />

                </div>


                <div>
                    < p className="text-base font-medium text-white"> Appuntamento </ p>
                    <div className="mt-2.5">
                        <input type="time" value={appointment} onChange={e => setAppointment(e.target.value)} placeholder="Appuntamento" className="block    w-full h-14 text-black placeholder-gray-500   bg-white border border-gray-200 rounded-md caret-blue-600 p-2" />
                    </div>
                </div>

                <div>
                    < p className="text-base font-medium text-white"> Orario inizio</ p>
                    <div className="mt-2.5   ">
                        <input type="time" value={hour} onChange={e => setHour(e.target.value)} placeholder="Inserisci ora" className="block    w-full h-14 text-black placeholder-gray-500   bg-white border border-gray-200 rounded-md caret-blue-600 p-2" />
                    </div>
                </div>

                <div>
                    < p className="text-base font-medium text-white"> Orario fine </ p>
                    <div className="mt-2.5   ">
                        <input type="time" value={end} onChange={e => setEnd(e.target.value)} placeholder="Inserisci ora" className="block    w-full h-14 text-black placeholder-gray-500   bg-white border border-gray-200 rounded-md   caret-blue-600 p-2" />
                    </div>
                </div>


                <div className="sm:col-span-2 mt-4">
                    <div className="h-0.5 bg-gray-200"></div>
                </div>
                <div className="sm:col-span-2">
                    < p className="text-xl  font-bold text-white"> Dettagli giocata </ p>

                </div>

                <div>
                    < p className="text-base font-medium text-white"> Titolo </ p>
                    <div className="mt-2.5   ">
                        <input name='titolo' type="text" value={title} onChange={e =>  setTitle(e.target.value) } placeholder="Inserisci titolo" className="block    w-full h-14 text-black placeholder-gray-500   bg-white border border-gray-200 rounded-md   caret-blue-600 p-2" />
                    </div>
                </div>

                <div>
                    < p className="text-base font-medium text-white"> Tipologia </ p>
                    <div className="mt-2.5   ">
                        <select value={type} onChange={e => setType(e.target.value)} placeholder="Inserisci tipologia" className="block    w-full h-14 text-black placeholder-gray-500   bg-white border border-gray-200 rounded-md   caret-blue-600 p-2">
                            {LOV_TYPE.map(t => <option value={t}>{t}</option>)}
                        </select>
                    </div>
                </div>

                <div>
                    < p className="text-base font-medium text-white"> Setup </ p>
                    <div className="mt-2.5   ">
                        <select value={setup} onChange={e => setSetup(e.target.value)} placeholder="Inserisci setup" className="block    w-full h-14 text-black placeholder-gray-500   bg-white border border-gray-200 rounded-md   caret-blue-600 p-2">
                            {LOV_SETUP.map(s => <option value={s}>{s}</option>)}
                        </select>
                    </div>
                </div>


                <div>
                    < p className="text-base font-medium text-white"> Campo </ p>
                    <div className="mt-2.5   ">
                        <select
                            className="block w-full h-14 text-black placeholder-gray-500   bg-white border border-gray-200 rounded-md   caret-blue-600 p-2"
                            value={campoOption}
                            onChange={e => {
                                const value = e.target.value;
                                setCampoOption(value);
                                if (value !== 'Altro') {
                                    setPlace(value);
                                } else {
                                    setPlace('');
                                }
                            }}
                        >
                            <option value="Castel San Giorgio">Castel San Giorgio</option>
                            <option value="Mercato San Severino">Mercato San Severino</option>
                            <option value="Altro">Altro</option>
                        </select>
                        {campoOption === 'Altro' && (
                            <input
                                type="text"
                                name='place'
                                value={place}
                                onChange={e => setPlace(e.target.value)}
                                placeholder="Inserisci campo"
                                className="block    w-full h-14 text-black placeholder-gray-500   bg-white border border-gray-200 rounded-md   caret-blue-600 p-2 mt-2"
                            />
                        )}
                    </div>
                </div>

                <div>
                    < p className="text-base font-medium text-white"> Luogo d'incontro </ p>
                    <div className="mt-2.5   ">
                        <input type="text" value={meeting} onChange={e => setMeeting(e.target.value)} placeholder="Inserisci luogo d'incontro" className="block    w-full h-14 text-black placeholder-gray-500   bg-white border border-gray-200 rounded-md   caret-blue-600 p-2" />
                    </div>
                </div>

 


                <div>
                    < p className="text-base font-medium text-white"> Info supplementari </ p>
                    <div className="mt-2.5   ">
                        <input type="text" value={info} onChange={e => setInfo(e.target.value)} placeholder="Info supplementari" className="block    w-full h-14 text-black placeholder-gray-500   bg-white border border-gray-200 rounded-md   caret-blue-600 p-2" />
                    </div>
                </div>


                <div className="sm:col-span-2">
                    <button onClick={() => handleSubmit()} className="inline-flex items-center justify-center w-full h-14 mt-2 text-base font-semibold text-white bg-[#839262] border border-transparent rounded-md focus:outline-none hover:bg-[#83926290] focus:bg-[#83926280]">
                        {editMode ? 'Aggiorna' : 'Invia'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AdminForm;
